import { AT_ACTIVITIES_INIT } from './constants';
import { IActivitiesInitAction } from './types';

export const activitiesInitAction = (
): IActivitiesInitAction => ({
        type: AT_ACTIVITIES_INIT,
    }
);
